import A from '../../comps/A';
import B from '../../comps/B';
import C from '../../comps/C';
import D from '../../comps/D';
import E from '../../comps/E';
import F from '../../comps/F';
import G from '../../comps/G';
import H from '../../comps/H';
import I from '../../comps/I';
import J from '../../comps/J';
import K from '../../comps/K';
import FixProcess from '../../comps/FixProcess';
import Compare from '../../comps/Compare';
import SwiperAni from '../../comps/SwiperAni';
import CanMove from '../../comps/CanMove';
import Accessories from '../../comps/Accessories';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import ScrollMagicFn from '@/utils/ScrollMagic';
import { TimelineMax, TweenMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import { useProductPageStatus } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import HighlightTextAni from '../../comps/HighlightTextAni';
import NumberAni from '../../comps/NumberAni';
import AutoSave24Ani from '../../comps/AutoSave24Ani';
import ListAni from '../../comps/ListAni';
import { useLang } from '@/i18n';
import App from '../../comps/App';
import Tabs from '../../comps/Tabs';
import Roof from '../../comps/Roof';
import TNC from '../../comps/TNC';
import { useRouter } from 'next/router';
import BottomAction from '../../comps/BottomAction';

const Overview: React.FC<{ setActivetedTabs: any }> = ({ setActivetedTabs }) => {
    const pageStatus = useProductPageStatus();
    const { t } = useLang('dpux');
    const { locale = '' } = useRouter();
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
        if (!window?.ScrollMagic) {
            window.ScrollMagic = ScrollMagicFn();
            ScrollMagicPluginGsap(window.ScrollMagic, TweenMax, TimelineMax);
        }
    }

    return (
        <div className={`overview ${css.page}`}>
            <BottomAction />
            <A />
            <B />
            <C />
            <FixProcess />
            {((pageStatus !== IPageStatus.REGULAR && locale === 'us') ||
                ([IPageStatus.TEASER, IPageStatus.SUPER_EARLY].includes(pageStatus) && locale === 'ca')) && <D setActivetedTabs={setActivetedTabs} />}
            <E />
            <div className="range1">
                <F />
                <G />
                <H />
                <I />
            </div>
            <div className="range2">
                {locale === 'us' && (
                    <>
                        <J />
                        <K />
                        {/* hzihhuang ⬇️ */}
                        <Compare />
                        <SwiperAni />
                        <CanMove />
                    </>
                )}
            </div>
            <div className="range3">
                <HighlightTextAni
                    title={t('HighlightTextAni3.title')}
                    desc={t.rich('HighlightTextAni3.desc', {
                        sup: (v: string) => <sup>{v}</sup>,
                    })}
                    id="delta-pro-ultra-x-O"
                    footer={t('item_Remarks3')}
                />
                <ListAni />
            </div>
            <div className="range4">
                <HighlightTextAni title={t('HighlightTextAni4.title')} desc={t('HighlightTextAni4.desc')} id="delta-pro-ultra-x-Q" />
                <NumberAni />
                <AutoSave24Ani />
                <Roof />
            </div>
            <div className="range5">
                <Tabs />
            </div>
            <div className="range6">
                <App />
                {locale !== 'ca' && <Accessories />}
            </div>
            <TNC />
        </div>
    );
};

export default Overview;
